import React, {
  createContext,
  useReducer,
  useContext
} from 'react';
import PropTypes from 'prop-types';

const SearchContext = createContext();

const searchReducer = (state, action) => {
  switch (action.type) {
    case 'SHOW_SEARCH': {
      return {
        ...state,
        isOpened: true
      };
    }

    case 'CLOSE_SEARCH': {
      return {
        ...state,
        isOpened: false
      };
    }

    case 'UPDATE_QUERY': {
      return {
        ...state,
        query: action.payload
      };
    }

    case 'SET_ALGOLIA_USER_TOKEN': {
      return {
        ...state,
        userToken: action.payload
      };
    }

    case 'UPDATE_ALGOLIA_SEARCH_PARAMS': {
      const { queryID = null, objectID = null } = action.params;
      const algoliaParams = {};

      if (queryID !== null) algoliaParams.queryID = queryID;
      if (objectID !== null) algoliaParams.objectIDs = [objectID];

      return { ...state, ...algoliaParams };
    }

    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

const SearchProvider = ({ children }) => {
  const [state, dispatch] = useReducer(searchReducer, {
    isOpened: false,
    query: '',
    queryID: '',
    indexName: '',
    objectIDs: [],
    userToken: ''
  });

  const open = () => dispatch({ type: 'SHOW_SEARCH' });
  const close = () => dispatch({ type: 'CLOSE_SEARCH' });
  const updateQuery = (query) => dispatch({
    type: 'UPDATE_QUERY',
    payload: query
  });
  const setAlgoliaUserToken = (userToken) => dispatch({
    type: 'SET_ALGOLIA_USER_TOKEN',
    payload: userToken
  });
  const updateAlgoliaSearchParams = (params) => dispatch({
    type: 'UPDATE_ALGOLIA_SEARCH_PARAMS',
    params
  });

  const value = {
    state,
    open,
    close,
    updateQuery,
    updateAlgoliaSearchParams,
    setAlgoliaUserToken,
    dispatch
  };

  return <SearchContext.Provider value={value}>{children}</SearchContext.Provider>;
};

SearchProvider.propTypes = {
  children: PropTypes.node.isRequired
};

const useSearch = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearch must be used within a SearchProvider');
  }
  return context;
};

export { SearchProvider, useSearch };
